import axios from "axios";

// Cliente HTTP central. O dev usa o proxy do Vite (/api → http://localhost:5000),
// então a baseURL relativa funciona em dev e em produção (mesmo host).
const api = axios.create({
  baseURL: "/api",
  timeout: 30000,
});

export const TOKEN_STORAGE_KEY = "tecmovel.turismo.token";
export const USER_STORAGE_KEY = "tecmovel.turismo.user";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Token expirado / inválido — limpa para forçar novo login
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      localStorage.removeItem(USER_STORAGE_KEY);
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
